import { type ComponentProps, memo } from 'react'

import View from './Field.view'

export type ControllerProps = ComponentProps<typeof View>

export const Controller = memo(function FieldController(props: ControllerProps) {
  return <View {...props} />
})

Controller.displayName = 'Field_Controller'

export default Controller
